export const CHAT_INPUT_MAX_CHARS = -1;

export const defaultAddMenuItems = [
  { icon: 'attach_file', text: 'Upload File', value: 'upload', showTag: true, tagColor: 'success' },
  {
    icon: 'hardDrive2',
    text: 'Add from AIMS Drive',
    value: 'drive',
    showTag: true,
    tagColor: 'success',
  },
  {
    title: 'Modes',
    defaultOpen: true,
    hideChevron: true,
    items: [
      { text: 'Web Search', value: 'web', showTag: true, tagColor: 'lightBlue' },
      {
        text: 'Deep Search',
        value: 'deep',
        showTag: true,
        tagColor: 'success',
        menu: [
          { value: 'sandbox', label: 'Sandbox' },
          { value: 'truth', label: 'Truth' },
          { value: 'web_search', label: 'Web search' },
        ],
        menuLabel: 'Source',
        menuType: 'grey',
      },
      {
        text: 'Tools Mode',
        value: 'tools',
        showTag: true,
        tagColor: 'success',
        menu: [
          { value: 'inventory', label: 'Inventory search' },
          { value: 'customer', label: 'Customer search' },
        ],
        menuLabel: 'Tool',
        menuType: 'grey',
      },
      {
        text: 'Reasoning Mode',
        value: 'reasoning',
        showTag: true,
        tagColor: 'success',
        menu: [
          { value: 'high', label: 'High' },
          { value: 'medium', label: 'Medium' },
          { value: 'low', label: 'Low' },
        ],
        defaultMenuValue: 'medium',
        menuType: 'purple',
      },
      {
        text: 'Custom Mode',
        value: 'custom',
        items: [
          { text: 'Customer Search', value: 'customer', showTag: true, tagColor: 'lightBlue' },
          { text: 'Inventory Mode', value: 'inventory', showTag: true, tagColor: 'success' },
          {
            icon: 'settings',
            text: 'Custom',
            value: 'custom_settings',
            showTag: true,
            tagColor: 'success',
          },
        ],
      },
      {
        text: 'More',
        value: 'more',
        items: [
          { text: 'Send Email', value: 'email', showTag: true, tagColor: 'success' },
          { text: 'Create Note', value: 'note', showTag: true, tagColor: 'success' },
        ],
      },
    ],
  },
];
